var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavouriteQueries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.186,
    height: 20.506,
    viewBox: "0 0 21.186 20.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": "W8U7Qn.tif"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.892,13.057c-.028.048,0,.11.011.159.278,1.217.926,2.5,1.203,3.726.611,2.706-2.286,4.572-4.507,2.974l-3.025-2.225c-1.007.711-1.978,1.537-2.996,2.225-2.135,1.445-4.657.089-4.609-2.456.318-1.494.933-2.908,1.327-4.383l-3.377-2.473c-1.836-1.778-.768-4.797,1.819-4.97l3.958-.017,1.25-3.843c1.174-2.478,4.408-2.337,5.375.279.432,1.168.701,2.403,1.156,3.565l4,.017c2.549.184,3.626,3.226,1.778,4.97l-3.366,2.452ZM13.213,7.154c-.099-.099-.168-.249-.223-.378-.582-1.378-.856-3.043-1.44-4.44-.429-.75-1.491-.751-1.921,0-.59,1.397-.857,3.099-1.451,4.471-.19.438-.451.577-.92.612-1.458.11-3.177-.162-4.599-.002-.846.095-1.19,1.222-.623,1.824l3.894,2.856c.266.258.315.552.251.913-.466,1.568-1.087,3.103-1.456,4.691.035.762.812,1.27,1.526.969,1.313-.774,2.519-2.008,3.811-2.773.324-.192.635-.235.98-.05l3.804,2.781c.836.437,1.746-.29,1.572-1.199l-1.42-4.419c-.064-.361-.015-.654.251-.913l3.851-2.817c.608-.625.32-1.674-.542-1.86-1.51-.092-3.141.111-4.636-.002-.261-.02-.518-.074-.708-.265Z",
    fill: "#bababa"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteQueries);
export default __webpack_public_path__ + "static/media/FavouriteQueries.69554bd7.svg";
export { ForwardRef as ReactComponent };